<template>
  <div class="layers" :class="{ 'eng': SC.U === ENG, 'chi': SC.U === CHI }">

    <!-- <KeyImage v-if="showKeyImage" class="key-image" ref="key-image" /> -->

    <div class="scroller" ref="scroller" :class="{ 'solid-bg': show.solidBG }">
      <div class="long-content" ref="content">
        <div class="brand-title-taller"></div>

        <div class="fb-back-gradient" v-show="iPhone7FacebookBrowser"></div>
        <div class="safari-back-gradient"></div>

        <div class="brand-first-fold" ref="brand-first-fold">
          <div class="brand-title-text">Clé de Peau Beauté</div>

          <div class="raidance-title">
            RADIANCE IS
          </div>

          <div class="raidance-text-row">
            <!-- <span class="break375"><br/></span> -->
            <div class="raidance-text" v-if="SC.U === CHI">「Radiance Is」慈善活動已成功籌得5,000顆閃耀力量，給予願望童更多機會實現改寫生命的願望。Clé de Peau Beauté 謹代表願望童感謝您的支持及參與。城中名人亦分享他們的閃耀故事，譜出動人的美麗時刻。</div>
            <div class="raidance-text" v-if="SC.U === ENG">“Radiance Is” has raised 5,000 radiance and granted life-changing wishes to more children in need. On behalf of Wish Children, Clé de Peau Beauté would like to thank you for your participation. Celebrities are passing on the radiance with their radiance moments.</div>
          </div>

          <div class="inline-cta above-fold">
            <img class="inline-cta-img inline-cta-mobile" src="./img/cta-v3/cta-mobile.png" alt="">
            <img class="inline-cta-img inline-cta-desktop" src="./img/cta-v3/cta-desktop.png" alt="">
            <div class="inline-cta-text" v-if="ST.U === CHI" @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()">
              細閱他們的閃耀故事
            </div>
            <div class="inline-cta-text" v-if="ST.U === ENG" @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()">
              Their Radiance Moment
            </div>
          </div>

          <div class="read-radiance-row" @click="$router.push('/data-form')">
            <div class="read-radiance" v-if="ST.U === CHI">
              率先預覽閃耀資訊
            </div>
            <div class="read-radiance" v-if="ST.U === ENG">
              RECEIVE OUR LATEST NEWS
            </div>
          </div>

          <!-- <div class="promo-top-padding">
          </div> -->

          <!-- <div class="raidance-promo-row" :class="{ 'show-promo': show.promo }" ref="promo-group">
            <div class="raidance-promo raidance-promo-title">
              <span v-if="SC.U === ENG">
                Unlock radiance for donation
              </span>
              <span v-if="SC.U === CHI">
                開啟閃耀力量
              </span>
            </div>
          </div>

          <div class="raidance-promo-row" :class="{ 'show-promo': show.promo }" ref="promo-group">
            <div class="raidance-promo center767" v-if="SC.U === ENG">
              From April 4-29, raise 5,000 radiance for the Wish Children and <span class="break767"><br/></span> Clé de Peau Beauté will donate HK$150,000 to Make-A-Wish Hong Kong.
            </div>
            <div class="raidance-promo" v-if="SC.U === CHI">
              在4月4日至29日，為願望童籌集5,000個閃耀力量，Clé de Peau Beauté將會向願望成真基金捐出港幣$150,000， 傳承閃耀。
            </div>
          </div> -->

        </div>

        <!-- <div class="counter-taller"></div>
        <div class="counter-element-row">
          <Counter class="counter-element" :ready="show.counter" :now="3456" :full="5000" :daysToGo="daysToGo" />
        </div> -->

        <!-- <div class="countdown-taller"></div>

        <div class="countdown-group" :class="{ 'show-countdown': show.countDown }" ref="countdown-group">
          <div class="c-days">
            <div class="counter2f">
              15
              <span class="counter-2fd" v-if="ST.U === CHI">
                {{ T('/@counter-days') }}
              </span>
            </div>
            <div class="counter-2fd" v-if="ST.U === ENG">
              {{ T('/@counter-days') }}
            </div>
          </div>
          <div class="c-raidance">
            <div class="counter2f">
              500
            </div>
            <div class="counter-2fd">
              {{ T('/@counter-radiance') }}
            </div>
          </div>
          <div class="c-radiance-to-go">
            <div class="counter-2fd">
              {{ T('/@counter-radiance-to-go-to-go') }}
            </div>
            <div class="counter2f">
              15,000
            </div>
            <div class="counter-2fd">
              {{ T('/@counter-radiance-to-go') }}
            </div>
          </div>

        </div> -->

        <div class="kol-taller"></div>
        <div class="kol-div" ref="kol-section" :class="{ 'show-kol-section': show.kolSection }">

          <div class="kol-section-title-taller"></div>
          <div class="kol-section-title">
            {{ T('/@radiance-is') }}
          </div>
          <!-- <div class="kol-section-subtitle">
            What is their radiance?
          </div> -->

          <div class="ig-row">
            <div class="ig-box">
              <div class="ig-title">
                <div class="ig-icon">
                  <img src="./img/ig-icon.svg" alt="">
                </div>
                <div class="ig-hashtag"  @click="openIG({ link: 'ig' })">#</div>
                <div class="ig-word"  @click="openIG({ link: 'ig' })">RADIANCEIS</div>
              </div>
              <div class="ig-images">
                <div class="ig-thumbnail ig-t1"  @click="openIG({ link: '1' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t2"  @click="openIG({ link: '2' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t3"  @click="openIG({ link: '3' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t4"  @click="openIG({ link: '4' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t5"  @click="openIG({ link: '5' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t6"  @click="openIG({ link: '6' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>

                <div class="ig-thumbnail ig-t7"  @click="openIG({ link: '7' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t8"  @click="openIG({ link: '8' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
                <div class="ig-thumbnail ig-t9"  @click="openIG({ link: '9' })">
                  <img class="ig-play-vid-icon" src="./img/play-video-icon.svg" alt="">
                </div>
              </div>
            </div>
          </div>

          <div class="moodboard-row">
            <div class="moodboard-layout">

              <div class="ml-taller" :class="{ [kol.tallerClass]: true }" :key="kol.id" v-for="kol in kols">

                <div class="ml-pic" @click="goYoutube(kol.youtube, kol.embed)" :class="{ [kol.picClass]: true }">
                  <img src="./img/play-video-icon.svg" alt="">
                </div>

                <div class="ml-desc" :class="{ [kol.descClass]: true }">
                  <div class="ml-radiance">{{ TT(kol.radiance) }}</div>
                  <div class="ml-name">{{ TT(kol.name) }}</div>
                  <div class="ml-role">{{ TT(kol.role) }}</div>
                  <div class="ml-role-desc" v-if="kol.desc">{{ TT(kol.desc) }}</div>
                </div>

              </div>


            </div>
          </div>

          <div class="kol-bg">

          </div>

          <div class="kol-cta-row">
            <div class="inline-cta">
              <img class="inline-cta-img inline-cta-mobile" src="./img/cta-v3/cta-mobile.png" alt="">
              <img class="inline-cta-img inline-cta-desktop" src="./img/cta-v3/cta-desktop.png" alt="">
              <div class="inline-cta-text" v-if="ST.U === CHI" @click="$router.push('/data-form')">
                率先預覽閃耀資訊
              </div>
              <div class="inline-cta-text" v-if="ST.U === ENG" @click="$router.push('/data-form')">
                RECEIVE OUR LATEST NEWS
              </div>
            </div>
          </div>




          <!-- <div class="kol-end-padding"></div> -->

          <!-- <div class="taller"></div>
          <div class="taller"></div> -->

          <!-- Welcome page. -->

          <!-- <br />
          <router-link to="/">/ (root)</router-link>

          <router-link to="/adjuster">/adjuster</router-link>
          <router-link to="/photo-camera">/photo-camera</router-link>

          <router-link to="/vase">/vase</router-link>
          <router-link to="/vortex">/vortex</router-link>
          <router-link to="/shooting-stars">/shooting-stars</router-link>
          <router-link to="/happy">/happy</router-link>
          <router-link to="/bally">/bally</router-link>
          <router-link to="/same-webgl-different-dom">/same-webgl-different-dom</router-link>

          <div class="toucher" ref="toucher">Toucher Debugger for vortex</div>


          <div class="taller"></div>
          1
          <div class="taller"></div>
          2
          <div class="taller"></div>
          3
          <div class="taller"></div>
          4
          <div class="taller"></div>
          5
          <div class="taller"></div>
          6
          <div class="taller"></div>
          7
          <div class="taller"></div> -->

        </div>

        <!-- <div class="taller"></div> -->

      <!-- End -->
      </div>
    </div>


    <div class="cta-row" ref="cta-row" v-if="!fsMenu" v-show="ctaVisible">

      <div class="kol-image-fader" ref="kol-image-fader" :class="{ 'show-kol-pad': show.kolPad }"></div>
      <div class="kol-image-fader cta-fader" :class="{ 'show-kol-pad': !show.kolPad }"></div>
      <div class="cta-res">

        <!--
        <img class="cta-svg cta-320" src="./img/cta-320.svg" alt="">
        <img class="cta-svg cta-376" src="./img/cta-376.svg" alt="">
        <img class="cta-svg cta-414" src="./img/cta-414.svg" alt="">
        <img class="cta-svg cta-473" src="./img/cta-473.svg" alt="">
        <img class="cta-svg cta-577" src="./img/cta-577.svg" alt="">
        -->

        <!--  -->
        <img class="cta-mobile" @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()" src="./img/cta-v3/cta-mobile.png" alt="">
        <img class="cta-desktop" @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()" src="./img/cta-v3/cta-desktop.png" alt="">
        <!-- <img class="cta-desktop" src="./img/cta-v2/desktop.png" alt=""> -->
        <!-- <img class="cta-mobile" src="./img/cta-v2/mobile.png" alt=""> -->
        <!-- <img class="cta-desktop" src="./img/cta-v2/cta-desktop.svg" alt=""> -->

        <!-- <div class="cta-call" v-if="ST.U === ENG">
          <span @click="$router.push('/data-form')" >
            <span class="break">RECEIVE OUR  <br /> LATEST NEWS</span>
            <span class="no-break">RECEIVE OUR LATEST NEWS</span>
          </span>
        </div> -->

        <div class="cta-call-chi" v-if="ST.U === CHI">
          <span @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()" >
          細閱他們的閃耀故事

          </span>
        </div>
        <div class="cta-call-chi" v-if="ST.U === ENG">
          <span @click="$router.push({ path: '/', hash: 'kol' }); checkScroll()" >
          Their Radiance Moment
          </span>
        </div>

        <div class="read-radiance-row" @click="$router.push('/data-form')">
          <div class="read-radiance" v-if="ST.U === CHI">
            率先預覽閃耀資訊
          </div>
          <div class="read-radiance" v-if="ST.U === ENG">
            RECEIVE OUR LATEST NEWS
          </div>
        </div>

      </div>

    </div>

    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false; checkScroll() }" @lang="() => { toggle() }" />
    <FullVideo class="full-video" v-if="fullVideo" @close="() => { fullVideo = false; }" :embed="youtubeLink" />
  </div>

</template>

<script>
import KeyImage from '@/components/Parts/KeyImage/KeyImage.vue'
import Counter from '@/components/DOM/Counter/Counter.vue'
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as Server from '@/components/DOM/Server/Server.js'

import * as Perf from '@/components/DOM/Perf.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

import FullVideo from './VideoPopUp.vue'

export default {
  components: {
    KeyImage,
    FloatMenu,
    FullMenu,
    Counter,
    FullVideo
  },
  data () {
    let daysToGo = 0

    var now = new Date().getTime()
    var countDownDate = new Date('April 29, 2018 23:59:00').getTime()

    var diff = countDownDate - now

    var days = Math.ceil(diff / (1000 * 60 * 60 * 24))

    daysToGo = days

    if (days > 27) {
      daysToGo = 27
    }
    if (days < 0) {
      daysToGo = 0
    }

    return {
      iPhone7FacebookBrowser: false,
      ctaVisible: false,
      daysToGo,
      hasPerf: Perf.hasPerf,
      Server,
      showKeyImage: true,
      fullVideo: false,
      youtubeLink: '',
      kols: [
        {
          id: 'Coco',
          youtube: 'https://youtu.be/qotwDaowO80',
          embed: 'https://www.youtube.com/embed/qotwDaowO80?rel=0',
          tallerClass: 'ml-taller-1',
          picClass: 'ml-pic-1',
          descClass: 'ml-desc-1',
          radiance: {
            [Text.ENG]: 'Journey',
            [Text.CHI]: 'Journey'
          },
          name: {
            [Text.ENG]: 'Coco Lee',
            [Text.CHI]: '李玟'
          },
          role: {
            [Text.ENG]: 'Singer',
            [Text.CHI]: '知名藝人'
          }
        },
        {
          id: 'check-yee',
          youtube: 'https://youtu.be/ak2tYQkXFaw',
          embed: 'https://www.youtube.com/embed/ak2tYQkXFaw?rel=0',
          tallerClass: 'ml-taller-2',
          picClass: 'ml-pic-2',
          descClass: 'ml-desc-2',
          radiance: {
            [Text.ENG]: 'Uncompromising',
            [Text.CHI]: 'Uncompromising'
          },
          name: {
            [Text.ENG]: 'Cheuk Yin',
            [Text.CHI]: '卓妍'
          },
          role: {
            [Text.ENG]: 'Wish Alum and Volunteer',
            [Text.CHI]: '願望童及義工'
          },
          desc: {
            [Text.ENG]: 'Being a cancer survivor, \nshe inspires other and passes on the radiance.',
            [Text.CHI]: '勇敢戰勝癌魔，\n以自身的勵志故事，\n成為他人的「希望之光」。'
          }
        },
        {
          id: 'anita',
          youtube: 'https://youtu.be/UOyvSfz6lLc',
          embed: 'https://www.youtube.com/embed/UOyvSfz6lLc?rel=0',
          tallerClass: 'ml-taller-3',
          picClass: 'ml-pic-3',
          descClass: 'ml-desc-3',
          radiance: {
            [Text.ENG]: 'Kindness',
            [Text.CHI]: 'Kindness'
          },
          name: {
            [Text.ENG]: 'Anita Yuen',
            [Text.CHI]: '袁詠儀'
          },
          role: {
            [Text.ENG]: 'Actress',
            [Text.CHI]: '知名藝人'
          }
        },
        {
          id: 'emilay-lam',
          youtube: 'https://youtu.be/6n9J48mXXlA',
          embed: 'https://www.youtube.com/embed/6n9J48mXXlA?rel=0',
          tallerClass: 'ml-taller-4',
          picClass: 'ml-pic-4',
          descClass: 'ml-desc-4',
          radiance: {
            [Text.ENG]: 'Self-confidence',
            [Text.CHI]: 'Self-confidence'
          },
          name: {
            [Text.ENG]: 'Emily\n Lam Ho',
            [Text.CHI]: '林恬兒'
          },
          role: {
            [Text.ENG]: 'Philanthropist',
            [Text.CHI]: '慈善名媛'
          }
        },
        {
          id: 'niki-chow',
          youtube: 'https://youtu.be/PzBiGNDHUHE',
          embed: 'https://www.youtube.com/embed/PzBiGNDHUHE?rel=0',
          tallerClass: 'ml-taller-5',
          picClass: 'ml-pic-5',
          descClass: 'ml-desc-5',
          radiance: {
            [Text.ENG]: 'Sharing',
            [Text.CHI]: 'Sharing'
          },
          name: {
            [Text.ENG]: 'Niki Chow',
            [Text.CHI]: '周麗淇'
          },
          role: {
            [Text.ENG]: 'Singer and Actress',
            [Text.CHI]: '知名藝人'
          }
        }
      ],
      fsMenu: false,
      ENG: Text.ENG,
      CHI: Text.CHI,
      TT: Text.TT,
      ST: Text.state,
      SC: Text.state,
      T: Text.T,
      toggle: Text.toggle,
      show: {
        solidBG: false,
        counter: false,
        promo: false,
        kolPad: false,
        countDown: false,
        kolSection: false
      },
      clean () {}
    }
  },
  afterEnter () {
    // this.showKeyImage = false
    // setTimeout(() => {
    //   this.showKeyImage = true
    //   this.$forceUpdate()
    // }, 100)
  },
  mounted () {
    window.dataLayer = window.dataLayer || []
    function gtag () { window.dataLayer.push(arguments) }
    gtag('event', 'conversion', {
      'allow_custom_scripts': true,
      'send_to': 'DC-6305702/mawhome/2018m00+standard'
    })

    // this.ctaVisible = false
    // setTimeout(() => {
    //   this.ctaVisible = true
    //   this.$nextTick(() => {
    //     this.ctaVisible = false
    //     this.$nextTick(() => {
    //       this.ctaVisible = true
    //     })
    //   })
    // }, 100)

    // this.ctaVisible = false

    if (this.isFBUA() && window.innerWidth === 375 && window.innerHeight === 667) {
      this.$refs['cta-row'].style.bottom = '125px'
      this.iPhone7FacebookBrowser = true
      // this.$refs['brand-first-fold'].style.backgroundImage = `linear-gradient(0deg, transparent, rgba(7, 0, 42, 0.82) 50%, rgba(7, 0, 42, 0.48) 90%, transparent)`
    }
    // this.iPhone7FacebookBrowser = true

    this.checkScroll()
    // this.$emit('toucher', this.$refs['toucher'])

    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  computed: {
    scrollPos: {
      get () {
        return 0
      },
      set (v) {
        console.log(v)
        // let counterA = 500
        let kolImageFader = 200
        let showPromo = 200
        let showCounter = 400
        let showKOL = 200
        let solidBG = 900

        // if (window.innerWidth > 415) {
        //   // kolImageFader += 200
        // }

        // if (window.innerWidth > 415) {
        //   // counterA += 200
        // }

        // let bbb = 0.092
        // if (v > counterA) {
        //   this.show.countDown = true
        //   // this.$refs['countdown-group'].style.opacity = 1.0
        // } else {
        //   this.show.countDown = false
        //   // this.$refs['countdown-group'].style.opacity = 0.0
        // }

        if (v > solidBG) {
          this.show.solidBG = true
        } else {
          this.show.solidBG = false
        }

        if (v > showPromo) {
          this.show.promo = true
        } else {
          this.show.promo = false
        }

        if (v > showCounter) {
          this.show.counter = true
        } else {
          this.show.counter = false
        }

        if (v > kolImageFader) {
          this.show.kolPad = true
        } else {
          this.show.kolPad = false
        }
        if (v > showKOL) {
          this.show.kolSection = true
        } else {
          this.show.kolSection = false
        }
      }
    }
  },
  methods: {
    openIG ({ link }) {
      let links = {
        'ig': 'https://www.instagram.com/explore/tags/radianceis/',
        '1': 'https://www.instagram.com/p/BhLSbu2AmWK/?hl=zh-hk&taken-by=zelia',
        '2': 'https://www.instagram.com/p/BhMFd6TDq3K/?hl=zh-hk&taken-by=physit',
        '3': 'https://www.instagram.com/p/BhLUS8blDzt/?hl=zh-hk&taken-by=cceciliayeung',
        '4': 'https://www.instagram.com/p/BhwcVY9FHOb/',
        '5': 'https://www.instagram.com/p/BhN1n3Jlijv/?hl=en&taken-by=chaukeiyoga',
        '6': 'https://www.instagram.com/p/Bhf-ThzASEZ/?taken-by=caragmcilroy',
        '7': 'https://www.instagram.com/p/BhLYUOlHaEi/?taken-by=carmenyim',
        '8': 'https://www.instagram.com/p/BhVqOdMBUJs/?taken-by=vivianlukatelier',
        '9': 'https://www.instagram.com/p/Bhf9drfBQoQ/?taken-by=chloe_leungoe'
      }
      let url = links[link]
      if (!url) {
        return
      }
      var href = document.createElement('a')
      href.href = url
      href.target = '_blank'
      href.click()
    },
    isFBUA () {
      var ua = navigator.userAgent || navigator.vendor || window.opera
      return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1)
    },
    checkScroll () {
      if (window.location.hash === '#kol') {
        this.$refs['scroller'].scrollTop = this.$refs['kol-section'].offsetTop - 67
      }
    },
    goYoutube (url, youtubelink) {
      if (window.innerWidth < 768) {
        var href = document.createElement('a')
        href.href = url
        href.target = '_blank'
        href.click()
      } else {
        this.youtubeLink = youtubelink
        this.fullVideo = true
      }
    },
    findKOL (id) {
      return this.kols.find(ee => ee.id === id)
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
  transform: translate3d(0px, 0px, 0.1px);
}
.full-video{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}
.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.taller{
  height: 80vh;
}
.toucher{
  width: 200px;
  height: 200px;
  border: red solid 1px;
}
a, a:visited, a:active {
  color: silver;
}
.key-image{
  position: absolute;
  top: 126px;
  left: 0px;
}
.key-image{
  width: 100px;
}
.brand-title-taller{
  height: 360px;
}
.brand-title-text{
  /* text-transform: uppercase; */
  /* Clé de Peau beaute: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2.5px;
  text-align: center;
}
.raidance-title{
  margin-top: 20px;
  border: 0 solid #FFFFFF;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 38px;
  color: #FFFFFF;
  letter-spacing: 8.9px;
  text-align: center;
  line-height: 48px;
  text-shadow: 0 1px 1px rgba(255,255,255,0.50);
}

.raidance-text-row{
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.raidance-text{
  white-space: pre-wrap;
  width: 308px;
  /* Clé de Peau Beauté b: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 18px;
}


.raidance-promo-row{
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.raidance-promo{
  width: 308px;
  /* From 4th April to 29: */
  /* font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 15px;
  color: #CEBC9E;
  letter-spacing: 1.15px;
  line-height: 17px; */

  /* From 4th to 29th Apr: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 15px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 22px;

  opacity: 0;
  transition: opacity 1s;
}
.show-promo .raidance-promo{
  opacity: 1;
}
.raidance-promo-title{
  margin-top: 20px;
  text-transform: uppercase;
  /* Unlock radiance for: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 22px;
}
.counter-taller{
  height: 30px;
}
.number-desc{
  /* 5,000: */
  /* border: 0 solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1.2px;
}

.cta-row{
  width: 100%;
  position: fixed;
  bottom: 35px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cta-res{
  position: relative;
}
.cta-call{
  text-transform: uppercase;
  position: absolute;
  top: 18px;
  left: calc(50% - 221px / 2);
  width: 221px;
  /* UNLOCK your radiance: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 22px;
  text-shadow: 0.5px 0.5px 3px rgba(255,255,255,0.50);
}
.cta-call-chi{
  position: absolute;
  top: 28px;
  left: calc(50% - 221px / 2);
  width: 221px;
  /* 開啟您的閃耀力量: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: center;
  line-height: 22px;
  text-shadow: 0.5px 0.5px 3px rgba(255,255,255,0.50);
}
.cta-320{
  background-image: rgba(0,0,0,0.3);
  display: none;
}
.cta-376{
  background-image: rgba(0,0,0,0.3);
  display: none;
}
.cta-414{
  background-image: rgba(0,0,0,0.3);
  display: none;
}
.cta-473{
  background-image: rgba(0,0,0,0.3);
  display: none;
}
.cta-577{
  background-image: rgba(0,0,0,0.3);
  display: none;
}


.counter2f{
  /* 15: */
  font-family: PlayfairDisplay-Regular, PingFang-SC-Regular;
  font-size: 40px;
  color: #CEBC9E;
  letter-spacing: 0.5px;
  text-align: center;
  padding-bottom: 7px;
  margin-top: -7px;
}

.counter-2fd{
  /* Radiance: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: center;
  line-height: 16px;
}

.countdown-taller{
  height: 120px;
}

.countdown-group{
  /* position: absolute;
  top: 120px;
  left: 0px; */
  width: 100%;
  height: 185px;

  position: relative;
}
.countdown-group.show-countdown{

}

.c-days{
  position: absolute;
  top: 0px;
  left: calc(50% - 100px);
  transform: translate3d(50px,0,0.1px);
  transition: opacity 0.5s 0.0s, transform 1s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0.000001;
}
.c-raidance{
  position: absolute;
  top: 50px;
  right: calc(50% - 139px);
  transform: translate3d(-50px,0,0.1px);
  transition: opacity 0.5s 0.1s, transform 1s 0.1s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0.000001;
}
.c-radiance-to-go{
  position: absolute;
  top: 100px;
  left: calc(50% - 160px);
  transform: translate3d(50px,0,0.1px);
  transition: opacity 0.5s 0.2s, transform 1s 0.2s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0.000001;
}
.countdown-group.show-countdown .c-days{
  transform: translate3d(0px,0px, 0.1px);
  opacity: 1;
}
.countdown-group.show-countdown .c-raidance{
  transform: translate3d(0px,0px, 0.1px);
  opacity: 1;
}
.countdown-group.show-countdown .c-radiance-to-go{
  transform: translate3d(0px,0px, 0.1px);
  opacity: 1;
}

.kol-div{
  color: black;
  background-color: #F5EEDE;
  opacity: 0;
  transition: opacity 1s;
}
.show-kol-section.kol-div{
  opacity: 1;
}
/* @media screen and (max-width: 1439px) {
  .kol-div{
    opacity: 1.0;
  }
} */
.kol-taller{
  height: 26px;
}
.kol-image-fader{
  position: absolute;
  bottom: -35px;
  left: 0px;
  width: 100%;
  height: 210px;
  /* background-image: linear-gradient(180deg, rgba(245,216,166,0.0) 0%, #B1956A 50%, #6E542E 94%); */
  background-image: linear-gradient(180deg,hsla(38, 32%, 63%, 0),#c1aa86 50%,#84673cde 94%);
  opacity: 0;
  transform: translateY(100%);
  transition: opacity 0.5s, transform 1.5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.kol-image-fader.show-kol-pad{
  opacity: 1;
  transition: opacity 0.5s, transform 1.5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  transform: translateY(0px);
}

.kol-image-fader.cta-fader{
  background-image: linear-gradient(180deg, rgba(6, 12, 38, 0), #010102, #020513);
  transition: opacity 0.5s, transform 1.5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

.kol-image-fader.cta-fader.show-kol-pad{
  transition: opacity 0.5s, transform 1.5s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  transform: translateY(0px);
}


.kol-section-title-taller{
  height: 60px;
}
.kol-section-title{
  border: 0 solid #573A09;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 12px;
  color: #573A09;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 20px;
  text-transform: uppercase;
}

.kol-section-title{
  /* 她們的閃耀力量時刻: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 24px;
  color: #07002A;
  letter-spacing: 1.71px;
  text-align: center;
  line-height: 34px;
}

/* .kol-section-subtitle{
  margin-top: 15px;

  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 28px;
  color: #07002A;
  letter-spacing: 1px;
  text-align: center;
  line-height: 34px;
} */

.moodboard-row{
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

.moodboard-layout{
  width: 100%;
  max-width: 414px;
}

.ml-pic{
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}

.ml-pic img{
  transition: transform 1s;
}
.ml-pic:hover img{

  transform: scale(1.3);
}

.ml-desc{
  position: absolute;
}


.ml-radiance{
  text-transform: uppercase;
  border: 0 solid #07002A;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 11px;
  color: #07002A;
  letter-spacing: 0.85px;
  line-height: 25px;
}

.ml-taller{
  position: relative;
}

.ml-name{
  margin-top: 20px;
  /* Anita Yuen: */
  border: 0 solid #07002A;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 21px;
  color: #07002A;
  letter-spacing: 1.1px;
  line-height: 25px;
  white-space: pre-wrap;

}
@media screen and (width: 375px) {
 .ml-name{
   white-space: pre-wrap;
 }
}

.ml-role{
  /* Actress: */
  border: 0 solid #573A09;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 11px;
  color: #573A09;
  letter-spacing: 1px;
  line-height: 20px;
  margin-top: 5px;
}
.ml-role-desc{
  white-space: pre-line;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  color: #573A09;
  margin-top: 0px;

  /* font-size: 10px; */
  /* letter-spacing: 0px; */
  line-height: 16px;

  font-size: 11px;
  letter-spacing: 0.5px;
}

.ml-taller-1{
  height: 172px;
}

.ml-pic-1{
  background-image: url(./kol-v2/cdp-Coco_Lee.jpg);
  height: 100%;
  width: calc(240 / 375 * 100%);
}

.ml-desc-1{
  left: calc(240 / 375 * 100% + 20px);
  top: 20%;
}

.ml-taller-2{
  margin-top: 40px;
  height: 290px;
}
.ml-pic-2{
  right: 0px;
  background-image: url(./kol-v2/cdp-Cheuk_Yin.jpg);
  height: 245px;
  width: calc(179 / 375 * 100%);
}
.ml-desc-2{
  text-align: right;
  right: calc(179 / 375 * 100% + 20px);
  top: 20%;
}

.ml-taller-3{
  margin-top: -5px;
  height: 232px;
}

.ml-pic-3{
  left: 0px;
  background-image: url(./kol-v2/cdp_Anita_Yuen.jpg);
  height: 232px;
  width: calc(179 / 375 * 100%);
}

.ml-desc-3{
  text-align: left;
  left: calc(179 / 375 * 100% + 20px);
  bottom: 10%;
}



.ml-taller-4{
  margin-top: 50px;
  height: 172px;
}
.ml-pic-4{
  right: 0px;
  background-image: url(./kol-v2/cdp-Emily_Lam.jpg);
  height: 172px;
  width: calc(240 / 375 * 100%);
}
.ml-desc-4{
  text-align: right;
  right: calc(240 / 375 * 100% + 20px);
  top: 10%;
}


.ml-taller-5{
  margin-top: 40px;
  height: 232px;
}
.ml-pic-5{
  left: 0px;
  background-image: url(./kol-v2/cdp_Niki_Chow.jpg);
  height: 232px;
  width: calc(179 / 375 * 100%);
}
.ml-desc-5{
  text-align: left;
  left: calc(179 / 375 * 100% + 20px);
  top: 10%;
}

.kol-end-padding{
  height: 170px;
}


@media screen and (max-width: 414px) {
  .key-image{
    top: calc(99.3px);
    /* transform: scale(0.5) translateY(-90px); */
  }
  .brand-title-taller{
    height: calc(100vh - 384px);
  }
  .raidance-title{
    margin-top: 4px;
  }
  .raidance-text-row{
    margin-top: 15px;
  }
  .eng .raidance-text-row{
    margin-top: 5px;
  }
  .raidance-promo-row{
    margin-top: 10px;
  }
  .cta-320{
    display: none;
  }
  .cta-376{
    display: none;
  }
  .cta-414{
    display: block;
  }
  .raidance-text{
    width: 342px;
  }
  .raidance-promo{
    width: 342px;
  }
  .cta-row{
    bottom: 35px;
  }
}


@media screen and (max-width: 376px) {
  .key-image{
    top: calc(87.3px);
    /* transform: scale(0.5) translateY(-90px); */
  }
  .brand-title-taller{
    height: calc(100vh - 380px);
  }
  .raidance-title{
    margin-top: 0px;
  }
  .raidance-text-row{
    margin-top: 5px;
  }
  .raidance-promo-row{
    margin-top: 10px;
  }
  .cta-320{
    display: none;
  }
  .cta-376{
    display: block;
  }
  .cta-414{
    display: none;
  }
  .raidance-text{
    width: 313px;
  }
  .raidance-promo{
    width: 313px;
  }
  .cta-row{
    bottom: 35px;
  }
}


@media screen and (max-width: 321px) {
  .countdown-taller{
    height: 150px;
  }
  .kol-image-fader{
    height: 150px;
  }
  .kol-taller{
    height: 20px;
  }
  .countdown-group{
    transform: scale(0.6) translateY(-100px);
  }
  .key-image{
    top: 85px;
    transform: scale(0.5) translateY(-90px);
  }
  .brand-title-taller{
    height: calc(230px - 62px);
  }
  .kol-image-fader{
    bottom: -10px;
  }
  .raidance-title{
    margin-top: 2px;
  }
  .raidance-text-row{
    margin-top: 0px;
  }
  .cta-320{
    display: block;
  }
  .cta-376{
    display: none;
  }
  .cta-414{
    display: none;
  }
  .raidance-text{
    line-height: 18px;
    width: 285px;
  }
  .raidance-promo{
    margin-top: 10px;
    width: 285px;
  }
  .cta-row{
    bottom: 35px;
  }
}



@media screen and (min-width: 414px){
  .cta-414{
    display: block;
  }
}



@media screen and (min-height: 700px) and (min-width: 400px) {
  .key-image{
    top: calc(100px);
    transform: scale(1.5) translateY(5vh);
  }
  .brand-title-taller{
    height: calc(100vh - 452px);
  }
  /* .raidance-title{
    margin-top: 4vh;
  }
  .raidance-text-row{
    margin-top: 4vh;
  } */
  .cta-320{
    display: none;
  }
  .cta-376{
    display: none;
  }
  .cta-414{
    display: block;
  }
  .raidance-text{
    width: 375px;
  }
  .raidance-promo{
    width: 375px;
  }
  .cta-row{
    bottom: 35px;
  }
}

.no-break{
  display: none;
}

.promo-top-padding{
  height: 150px;
}
@media screen and (min-width: 374px) {
  .promo-top-padding{
    height: 250px;
  }
}

@media screen and (min-width: 414px) {
  .promo-top-padding{
    height: 300px;
  }
  .cta-call-chi{
    top: 31px;
  }
}

@media screen and (min-width: 767px) {
  .ml-pic img{
    width: 40px;
    height: 40px;
  }
  .kol-section-title{
    font-size: 30px;
  }
  .promo-top-padding{
    height: 350px;
  }
  .raidance-title {
    height: 48px;
    /* rADIANCE Is: */
    font-size: 60px;
    color: #FFFFFF;
    letter-spacing: 10px;
    text-align: center;
    line-height: 48px;
    text-shadow: 0 1px 1px rgba(255,255,255,0.50);
  }
  .raidance-text{
    /* Clé de Peau Beauté b: */
    /* font-size: 18px; */
    color: #FFFFFF;
    letter-spacing: 1px;
    /* line-height: 24px; */
    font-size: 18px;
    line-height: 28px;
    width: 553px;
    height: 108px;
  }
  .eng .raidance-text{
    line-height: 27px;
    width: 561px;
  }
  .raidance-text-row{
    height: 108px;
  }
  .chi .raidance-text-row{
    margin-top: 30px;
  }
  .eng .raidance-text-row{
    margin-top: 30px;
  }
  .raidance-promo{
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 27px;
    /* width: 415px; */
    width: 553px;
    /* height: 108px; */
  }
  .raidance-promo.raidance-promo-title{
    margin-top: 100px;
    font-size: 24px;
    letter-spacing: 1.5px;
  }
  .brand-title-text{
    font-size: 20px;
  }

  .ml-radiance{
    font-size: 15px;
  }
  .ml-name{
    font-size: 24px;
  }
  .ml-role{
    font-size: 13px;
    margin-top: 8px;
  }
  .ml-role-desc{
    /* font-size: 11px;
    line-height: 17px; */

    font-size: 13px;
    line-height: 17px;
    letter-spacing: 0.5px;
    width: 250px;
  }

}

@media screen and (min-width: 767px) {
  .cta-414{
    display: none;
  }
  .cta-473{
    display: none;
  }
  .cta-577{
    display: block;
  }
  .break{
    display: none;
  }
  .no-break{
    display: block;
  }
  .cta-call-chi,
  .cta-call{
    font-size: 20px;
    width: 473px;
    top: 51px;
    left: calc(50% - 473px / 2);
  }
  .cta-call{
    top: 43px;
  }
  .cta-call-chi{
    top: 42px;
  }
  .cta-svg.cta-473{
    width: 560px;
  }
}


/*

.kol-div{
  display: none !important;
}


.counter-element{
  display: none !important;
}
 */

.no-perf .long-content{
  background-image: url('../../Scenes/StarSkyBg/img/bg/starry-sky-375.jpg')
}
@media screen and (min-width: 767px) {
  .no-perf .long-content{
    background-image: url('../../Scenes/StarSkyBg/img/bg/starry-sky-1920.jpg')
  }
}

.break767{
  display: none;
}
@media screen and (min-width: 767px) {
  .break767{
    display: inline;
  }
}

@media screen and (width: 375px) {
  .chi .brand-title-text{
    transform: translateY(-9px);
  }
  .chi .raidance-title{
    transform: translateY(-9px);
  }
  .chi .raidance-title{
    transform: translateY(-9px);
  }
  .chi .raidance-text{
    width: 293px;
    line-height: 19px;
    transform: translateY(-9px);
  }
}

/* iphone x chrome */
@media screen and (width: 375px) and (min-height: 600px) {
  .brand-title-taller{
    height: calc(100vh - 405px);
  }
}
/* iphone x chrome */
@media screen and (width: 375px) and (min-height: 655px) {
  .brand-title-taller{
    height: calc(100vh - 425px);
  }
}

/* iphone x safari */
@media screen and (width: 375px) and (height: 635px) {
  .brand-title-taller{
    height: calc(100vh - 415px);
  }
}

.brand-first-fold{
  position: relative;
}

.fb-back-gradient{
  z-index: 0;
  position: absolute;
  top: 239px;
  left: 0px;
  width: 100%;
  height: 500px;
  background-image: linear-gradient(0deg, transparent, rgb(7, 0, 42) 50%, rgba(7, 0, 42, 0.4) 90%, transparent);
}

.safari-back-gradient{
  z-index: 0;
  display: none;
  position: absolute;
  top: 170px;
  left: 0px;
  width: 100%;
  height: 1000px;
  background-image: linear-gradient(0deg, transparent, rgb(7, 0, 42) 50%, rgba(7, 0, 42, 0.4) 90%, transparent);
}

@media screen and (max-width: 376px) {
  .safari-back-gradient{
    display: block;
  }
}

.ig-row{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.ig-box{
  width: 331px;
  /* height: 265px; */
  border: #CEBC9E solid 1px;
}

.ig-title{
  /* radianceis: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #BB9B62;
  letter-spacing: 1.08px;
  line-height: 25px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.ig-icon,
.ig-hashtag,
.ig-word{
  display: inline-block;
  cursor: pointer;
}

.ig-icon{
  margin-right: 4px;
}

.ig-hashtag{
  margin-left: 3px;
}

.ig-word{
  margin-left: 1px;
}

.ig-icon img{
  width: 14px;
  height: 14px;
  transform: translateY(1px);
}

.ig-images{
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.ig-thumbnail{
  position: relative;
  width: 97px;
  height: 97px;
  background-size: cover;
  margin: 3px;
  cursor: pointer;
}

.ig-t1{
  background-image: url('./ig-img/1.png');
}
.ig-t2{
  background-image: url('./ig-img/2.png');
}
.ig-t3{
  background-image: url('./ig-img/3.png');
}
.ig-t4{
  background-image: url('./ig-img/4.jpg');
}
.ig-t5{
  background-image: url('./ig-img/5.png');
}
.ig-t6{
  background-image: url('./ig-img/6.png');
}


.ig-t7{
  background-image: url('./ig-img/7.jpg');
}
.ig-t8{
  background-image: url('./ig-img/8.jpg');
}
.ig-t9{
  background-image: url('./ig-img/9.jpg');
}

.ig-play-vid-icon{
  position: absolute;
  right: 7px;
  bottom: 7px;
  width: 17px;
  height: 17px;
}

@media screen and (max-width: 321px) {
  .ig-box{
    transform: scale(0.9);
  }
  .ig-thumbnail{
    width: 94px;
    height: 94px;
  }
}

@media screen and (min-width: 413px) {
  .ig-thumbnail{
    width: 115px;
    height: 115px;
  }
  .ig-box{
    width: 380px;
  }
}

@media screen and (min-width: 767px) {
  .ig-icon img{
    width: 17px;
    height: 17px;
    transform: translateY(2px);
  }
  .ig-title{
    /* radianceis: */
    font-size: 20px;
    letter-spacing: 1.38px;
    line-height: 25px;
    margin-top: 30px;
  }
  .ig-images{
    margin-top: 25px;
    margin-bottom: 38px;
  }
  .ig-thumbnail{
    width: 170px;
    height: 170px;
    margin: 6px;
  }
  .ig-box{
    width: 612px;
  }
  .kol-section-title-taller{
    height: 100px;
  }
  .kol-section-title{
    font-size: 34px;
    letter-spacing: 2.43px;
    line-height: 34px;
  }
  .ig-play-vid-icon{
    width: 26px;
    height: 26px;
    right: 15px;
    bottom: 15px;
  }
}


.cta-desktop{
  display: none;
}
@media screen and (max-width: 321px){
  .cta-mobile{
    transform: translateY(16px) scale(0.85);
  }
  .cta-call-chi{
    top: 50px;
  }
  .cta-call{
    top: 40px;
  }
}
@media screen and (min-width: 322px) and (max-width: 766px) {
  .cta-mobile{
    transform: translateY(16px) scale(0.85);
  }
  .cta-call-chi{
    top: 50px;
  }
  .cta-call{
    top: 40px;
  }
}

@media screen and (min-width: 414px) and (max-width: 766px) {
  .cta-mobile{
    transform: translateY(16px);
  }
}

@media screen and (min-width: 767px) {
  .cta-mobile{
    display: none;
  }
  .cta-desktop{
    display: block;
    transform: translateY(3px);
  }
}

.inline-cta-mobile{
  display: block;
  transform: scale(0.85);
}
.inline-cta-desktop{
  display: none;
}

.inline-cta{
  position: relative;
  margin-top: 10px;
  /* height:  */
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.inline-cta-text{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  text-transform: uppercase;

  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: center;
  line-height: 22px;
  text-shadow: 0.5px 0.5px 3px rgba(255,255,255,0.50);
}

.read-radiance-row{
  z-index: 100;
  margin-top: 30px;
  text-align: center;
}
.read-radiance{
  z-index: 100;
  display: inline;
  /* 細閱他們的閃耀故事: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 0.72px;
  text-align: center;
  padding-bottom: 3px;
  border-bottom: #CEBC9E solid 1px;
}

.kol-bg{
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 150px;
  background-image: linear-gradient(180deg,hsla(38, 32%, 63%, 0),#c1aa86 50%,#84673cde 94%);
}

.kol-div{
  position: relative;
}

.kol-cta-row{
  margin-top: 40px;
  padding-bottom: 20px;
}

.inline-cta.above-fold {
  margin-top: 0px;
}

@media screen and (max-width: 321px) {
  /* .cta-row{
    bottom: 10px;
  } */
  .read-radiance-row{
    margin-top: 0px;
  }
}


@media screen and (min-width: 375px) {
  /* .cta-row{
    bottom: 15px;
  } */
  .read-radiance-row{
    margin-top: 0px;
  }
  .cta-mobile{
    transform: scale(1.0);
  }
  .eng .inline-cta.above-fold {
    margin-top: 5px;
  }
}

@media screen and (min-width: 414px) {
  /* .cta-row{
    bottom: 15px;
  } */

  .inline-cta.above-fold {
    margin-top: 15px;
  }
  .read-radiance-row{
    margin-top: 0px;
  }
}

@media screen and (min-width: 767px) {
  .inline-cta.above-fold {
    margin-top: 30px;
  }

  .read-radiance{
    /* 細閱他們的閃耀故事: */
    font-family: CronosPro-LtDisp, PingFangTC-Light;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.89px;
    text-align: center;
  }
  .inline-cta-text{
    font-family: CronosPro-LtDisp, PingFangTC-Light;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    text-align: center;
    line-height: 24px;
    text-shadow: 0.5px 0.5px 3px rgba(255,255,255,0.50);
  }
  .inline-cta-mobile{
    display: none;
  }
  .inline-cta-desktop{
    display: block;
  }
  .kol-bg{
    height: 180px;
  }
  .kol-cta-row{
    margin-top: 80px;
    padding-bottom: 30px;
  }
  .raidance-text{
    width: 608px;
  }
  .read-radiance-row{
    margin-top: 30px;
  }
  .kol-taller{
    height: 46px;
  }
}

.solid-bg{
  background-color:white;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Landing/Landing.vue